var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.655424 1.40027C1.19758 0.835326 2.10101 0.835326 2.64317 1.40027L7.88547 6.86291C7.90803 6.88642 7.91885 6.91701 7.91791 6.94732C7.91885 6.97762 7.90803 7.00821 7.88547 7.03172L2.64317 12.4944C2.10101 13.0593 1.19758 13.0593 0.655424 12.4944C0.143929 11.9614 0.143929 11.1198 0.655424 10.5868L4.14809 6.94732L0.655424 3.30784C0.143929 2.77485 0.143929 1.93327 0.655424 1.40027Z",
    fill: "#2D6CE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b786d51cdd43f14b127ee278e9b93177.svg";
export { ForwardRef as ReactComponent };